const state = {
 show: false,
 data: null,
 type: null,
 table_row_node_id: null
};

const actions = {
 showRightInfo({commit}, data) {
  // reset right info pane data and make sure hidden state
  commit("HIDE_RIGHT_INFO");
  commit('RESET_RIGHT_SIDE_STATE');
  // commit data to info pane and show
  return new Promise((resolve, reject) => {
   if (data.sub_type === 'no_id') {
    commit('COMMIT_RIGHT_SIDE_STATE', {data: data.data.worker, type: data.type});
   }
   else {
    commit('COMMIT_RIGHT_SIDE_STATE', {data: data.data, type: data.type});
   }
   
   resolve();
  }).then(() => {
   commit('SHOW_RIGHT_INFO');
   // resize main content when right info panel shown
   let main_content = document.getElementById('main_content_div');
   main_content.classList.add('show_main_content');
   // add class to vue router tab if tabs require additional room - scroll enabled
   setTimeout(() => {
    let tabs_width = getTabsElementWidth('router-tab', 'offsetWidth');
    let tab_container_width = getTabsElementWidth('router-tab__header', 'offsetWidth');
    if (tabs_width > tab_container_width) {
     $(".router-tab-header").addClass("is-scroll");
    }
   }, 130);
  });
 },
 
 hideRightInfo({commit}) {
  return new Promise((resolve, reject) => {
   commit('RESET_RIGHT_SIDE_STATE');
   resolve();
  }).then(() => {
   commit("HIDE_RIGHT_INFO");
   // expand main content to full size when right info tab is hidden
   let main_content = document.getElementById('main_content_div');
   main_content.classList.remove('show_main_content');
   // remove class from vue router tab if tabs don't require additional room - scroll
   setTimeout(() => {
    let tabs_width = getTabsElementWidth('router-tab', 'offsetWidth');
    let tab_container_width = getTabsElementWidth('router-tab__header', 'scrollWidth');
    if (tabs_width < tab_container_width) {
     $(".router-tab-header").removeClass("is-scroll");
    }
   }, 130);
  });
 }
};

function getTabsElementWidth(element, property) {
    if(document.body.classList.contains(element)) {
        return parseFloat(document.getElementsByClassName(element)[0].property);
    }

    return 0;
}

const mutations = {
 RESIZE_IF_RIGHT_INFO_SHOWN() {
  // resize main content when right info panel shown
  let main_content = document.getElementById('main_content_div');
  main_content.classList.add('show_main_content');
  let tabs_width = getTabsElementWidth('router-tab', 'offsetWidth');
    let tab_container_width = getTabsElementWidth('router-tab__header', 'scrollWidth');
  if (tabs_width > tab_container_width) {
   $(".router-tab-header").addClass("is-scroll");
  }
 },
 
 SHOW_RIGHT_INFO(state) {
  state.show = true;
 },
 
 HIDE_RIGHT_INFO(state) {
  state.show = false;
 },
 
 COMMIT_RIGHT_SIDE_STATE(state, payload) {
  state.data = payload.data;
  state.type = payload.type;
 },
 
 RESET_RIGHT_SIDE_STATE(state) {
  state.data = null;
  state.type = null;
 },
 
 CURRENT_RIGHT_INFO_TABLE_ROW(state, payload) {
  state.table_row_node_id = payload.node_id;
 },
 CLEAR_RIGHT_INFO_TABLE_ROW(state) {
  state.table_row_node_id = null;
 }
};

export default {
 state,
 actions,
 mutations
}
